import _get from 'lodash/get';
import _isEmpty from 'lodash/isEmpty';
import _find from 'lodash/find';
import { CUSTOMER_TYPE } from '../constants/customer.constants';
import { SUFFIXES, SALUTATIONS } from '../constants/deal/customer';
import CustomerReader from '../readers/Customer';
import { EMPTY_OBJECT } from '../app.constants';
export function getCustomerName(customer) {
  var companyName = CustomerReader.companyName(customer) || '';
  var customerType = CustomerReader.customerType(customer) || '';
  var firstName = CustomerReader.firstName(customer) || '';
  var lastName = CustomerReader.lastName(customer) || '';

  var salutationValue = _get(SALUTATIONS, CustomerReader.salutation(customer));

  var suffixValue = _get(SUFFIXES, CustomerReader.suffix(customer));

  var middleNameValue = CustomerReader.middleName(customer);
  var salutation = _isEmpty(salutationValue) ? '' : "".concat(salutationValue, " ");
  var middleName = _isEmpty(middleNameValue) ? '' : " ".concat(middleNameValue);
  var suffix = _isEmpty(suffixValue) ? '' : " ".concat(suffixValue);
  var name = CustomerReader.name(customer) || '';
  if (customerType === CUSTOMER_TYPE.BUSINESS) return companyName;
  if (_isEmpty(firstName) && _isEmpty(lastName)) return "".concat(salutation).concat(name);
  return "".concat(salutation).concat(firstName).concat(middleName, " ").concat(lastName).concat(suffix);
}
export var getCustomerNameBasedOnType = function getCustomerNameBasedOnType(customer) {
  var customerType = CustomerReader.customerTypeInteger(customer) || 0;
  return customerType === CUSTOMER_TYPE.INDIVIDUAL ? CustomerReader.customerName(customer) : CustomerReader.companyName(customer);
};
export var getCustomerId = function getCustomerId(customer) {
  var displayId = CustomerReader.displayId(customer);
  var externalId = CustomerReader.externalId(customer); // We have to remove externalId and use only displayId once the data is validated.

  return displayId || externalId;
};
export var getPrimaryPhone = function getPrimaryPhone(customer) {
  var phones = CustomerReader.phones(customer);
  var primaryPhoneData = _find(phones, ['isPrimary', true]) || EMPTY_OBJECT;
  return CustomerReader.number(primaryPhoneData);
};